import React, { useState } from 'react';
import AlertDialog from './AlertDialog';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, Typography } from '@mui/material';

export default function Login(props) {
    const [password, setPassword] = useState('');
    const [dataAlert, setDataAlert] = useState({ isShow: false, severity: '', title: '', message: '' });
    var MD5 = require('md5');
    const checkPassword = () => {
        if (MD5(password) === 'fa829981b8db60377fa2fae6f3df7561')
            props.onSubmit();
        else
            setDataAlert({ isShow: true, severity: 'error', title: 'Error', message: 'Your password is wronge.' });
    }

    return (
        <>
            <Dialog open={props.isShow}>
                <DialogTitle sx={{ backgroundColor: '#cfe8fc', color: 'blue' }}>Login</DialogTitle>
                <DialogContent>
                    <Typography variant="h6" gutterBottom align='center' sx={{ mt: '20px;' }}>
                        Enter password, please!
                    </Typography>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="password"
                        name="password"
                        type="password"
                        label="Password"
                        fullWidth
                        value={password}
                        onChange={(ev) => setPassword(ev.target.value)}
                        onKeyDown={(ev) => {
                            if (ev.key === 'Enter') {
                                checkPassword();
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={checkPassword} variant='contained'>Login</Button>
                </DialogActions>
            </Dialog>

            <AlertDialog data={dataAlert} onClose={e => setDataAlert({ isShow: false })} />
        </>
    );
}